"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Download, Smartphone, Apple, Monitor } from "lucide-react";

export function AppDownload() {
  return (
    <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
      <Badge variant="premium" size="sm" className="mb-2 sm:mb-0">
        Free Download
      </Badge>
      <div className="flex items-center gap-3">
        <Button variant="outline" size="lg" asChild>
          <a href="#" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
            <Apple className="h-5 w-5" />
            <div className="text-left">
              <div className="text-[0.625rem] text-muted-foreground leading-none">Download on the</div>
              <div className="text-xs font-semibold leading-tight">App Store</div>
            </div>
          </a>
        </Button>
        <Button variant="outline" size="lg" asChild>
          <a href="#" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2">
            <Monitor className="h-5 w-5" />
            <div className="text-left">
              <div className="text-[0.625rem] text-muted-foreground leading-none">Get it on</div>
              <div className="text-xs font-semibold leading-tight">Google Play</div>
            </div>
          </a>
        </Button>
      </div>
    </div>
  );
}